<template>
  <div
    class="owal panel carousel clipping wrapper"
  >
    <div
      class="owal panel carousel motion wrapper"
      :style="this.wrapperStyle"
    >
      <owal-panel
        v-for="panel in this.panels"
        :key="panel.title"
        :title="panel.title"
        :content="panel.content"
        :active="panelIsActive(panel)"
        @change="panelChanged"
      />
    </div>
  </div>
</template>

<script>
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'

export default {
  name: 'OwalPanelCarousel',
  components: { OwalPanel },
  props: {
    panels: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      offset: 0,
    }
  },
  computed: {
    wrapperStyle: function () {
      const style = 'transform: translate(-' + this.offset + 'rem, 0);'
      return style
    },
  },
  watch: {
    index: function (newValue, oldValue) {
      this.offset = 60.12 * newValue
    },
  },
  methods: {
    cssClass: function (panel) {
      const currentPanel = this.panels.indexOf(panel) === this.index
      return currentPanel ? 'active panel' : 'inactive panel'
    },
    panelIsActive: function (panel) {
      return this.panels && this.panels.indexOf(panel) === this.index
    },
    panelChanged: function (submission) {
      /*
      This is named something other than "change" since a carousel might have
      a change in the selected index, too. Multiple kinds of changes, mean we
      want as specific a name as possible.
      */
      this.$emit('inputChange', submission)
    },
  },
}
</script>

<style scoped>

@media only screen and (min-width: 961px) {
  .owal.panel.carousel.clipping.wrapper,
  .owal.panel {
    width: 50rem;
  }
}

@media only screen and (min-width: 400px) and (max-width: 960px)  {
  .owal.panel.carousel.clipping.wrapper,
  .owal.panel {
    width: 22rem;
  }
}

@media only screen and (max-width: 399px)  {
  .owal.panel.carousel.clipping.wrapper,
  .owal.panel {
    width: 10rem;
  }
}

.owal.panel.carousel.clipping.wrapper {
  margin: 3.19rem 0;
  height: 100%;
}

.owal.panel.carousel.clipping.wrapper .owal.panel.carousel.motion.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  height: 100%;
}

 .owal.panel {
  display: block;
  flex-shrink: 0;
}

.owal.panel.carousel.clipping.wrapper .owal.panel:not(:first-of-type) {
  margin-left: 5.06rem;
}

.owal.panel.carousel.clipping.wrapper .owal.panel:not(:last-of-type) {
  margin-right: 5.06rem;
}

.owal.panel.carousel.motion.wrapper {
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
}

.owal.panel.carousel.motion.wrapper .owal.panel.active.window,
.owal.panel.carousel.motion.wrapper .owal.panel.inactive.window {
  max-height: 90%;
  overflow: hidden;
}

</style>
